import { Link } from "react-router-dom";
import type { Film } from "@/types";

interface FilmCardProps {
  film: Film;
  /** 紧凑模式：列表/分栏场景下行内更简洁 */
  compact?: boolean;
}

export default function FilmCard({ film, compact = false }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-secondary-200">
        <img
          src={film.poster}
          alt={`${film.title}海报`}
          title={`${film.title}影视作品海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-label tracking-wide">
          {film.type}
        </span>
        <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-label">
          {film.year}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-foreground-950/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-fire-line text-accent-400"></i>
            热度 {film.heat.toLocaleString()}
          </span>
        </div>
      </div>
      <div className={compact ? "p-2.5" : "p-3"}>
        <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base truncate group-hover:text-primary-600 transition-colors">
          {film.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 truncate">
          {film.cast.slice(0, 2).join("、")}
        </p>
        {!compact && (
          <p className="mt-2 text-xs leading-relaxed text-foreground-500 line-clamp-2">
            {film.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}